/**
 * GeoZone types
 * Define zonas geográficas reutilizables que pueden ser referenciadas por otras entidades.
 */

import { MapPosition } from "../common";

export interface GeoZone {
    id: string;
    name: string;
    description?: string;
    accountId?: string | null; // null for system-wide zones (admin/integration created)
    area: MapPosition[]; // Spatial geometry polygon
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date | null;
}

export enum GeoZoneStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}